/* eslint-disable no-useless-catch */
import { allQuickLists, createQuickList } from 'api/mdl22'

export const getAllQuickListsAction = payload => async () => {
  try {
    const response = await allQuickLists(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    }
  } catch (err) {
    throw err
  }
}

export const createQuickListAction = payload => async () => {
  try {
    const response = await createQuickList(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    }
  } catch (err) {
    throw err
  }
}
